import { Status, StatusCode } from 'helpers/app.config';

export const errorService = {
  description: 'ticket.ticketStatus.misconfiguredService',
  id: 99998,
  hexColor: '#a62520'
};

export const noResultService = {
  description: 'ticket.ticketStatus.withoutResults',
  id: 99999,
  hexColor: '#939393'
};

export const ticketStatus = (Object.keys(Status) as unknown as StatusCode[])
  .filter((key) => Status[key].enabled)
  // filtro para que no haya ni programmed ni reopened
  .filter(
    (key) =>
      Number(key) !== StatusCode.Programmed &&
      Number(key) !== StatusCode.Reassign
  )
  .map((key) => ({
    name: Status[key].name,
    id: Number(key),
    color: Status[key].ganttColor || Status[key].color
  }))
  .concat(errorService, noResultService);

export const styles = {
  modal: {
    maxWidth: 'none',
    width: '80%',
    maxHeight: 1000,
    height: '85%'
  },
  serviceModal: {
    maxWidth: 'none',
    width: '60%',
    height: '60%',
    maxHeight: 800
  }
};
